/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import {Link} from 'react-router-dom'
import HeaderTable from '../BaseComponent/HeaderTable'
import ReactToPrint from 'react-to-print'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'

class SubFactors extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      subFactors: [],
      printInfo: [],
      lengthProducts: ''
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var {deliveryPackId} = this.props.match.params
    sessionStorage.setItem('params', `deliveryPackId=${deliveryPackId}`)

    // alert(deliveryPacketID)

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL}?deliveryPackId=${deliveryPackId}&export=true`, {})
      .then((response) => {
        sessionStorage.setItem('countAll', response.data.object.countAll)

        // alert(JSON.stringify(response.data));
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error))
      })

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL
        }?deliveryPackId=${deliveryPackId}&export=false&pageSize=10&pageNumber=1`,
        {}
      )
      .then((response) => {
        sessionStorage.setItem('countAll', response.data.object.countAll)

        // alert(JSON.stringify(response.data));
        if (response.data.error == null) {
          this.setState({
            subFactors: response.data.object.result,
            lengthProducts: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      subFactors: data
    })
  }

  changeDropDown(data) {
    this.setState({
      subFactors: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  render() {
    let excelURL = 'report/dispatch/deliveryPack/detail?export=true&' + sessionStorage.getItem('params')
    let url = 'report/dispatch/deliveryPack/detail?export=true'
    let urlParams = sessionStorage.getItem('params')

    // let url = 'report/dispatch/deliveryPack/detail?deliveryPackId=' + sessionStorage.getItem('params');
    let pageNumber = sessionStorage.getItem('pageNumber')
    let excelColumns = [
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام تامین کننده', value: 'providerName'},
      {title: 'تعداد', value: 'quantity'},
      {title: 'واحد شمارش', value: 'productUnitTitle'},
      {title: 'قیمت واحد', value: 'unitPrice'},
      {title: 'قیمت کل', value: 'totalAmount'},
      {title: 'تخفیف', value: 'discountAmount'},
      {title: 'قابل پرداخت', value: 'payableAmount'}
    ]

    var initialVal = 0
    var sumProduct = this.state.printInfo.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)

    var sumPrice = this.state.printInfo.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    return (
      <div className="rtl printA4Page">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>پارت تحویل رساننده</li>
            <li>ریز فاکتور رساننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={url}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={excelURL}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <ReactToPrint
                  trigger={() => (
                    <button className="printButton">
                      <i className="fas fa-print" />
                    </button>
                  )}
                  content={() => this.printPart}
                />
              </div>
            </div>

            <div className="printSection">
              <table className="printTable" ref={(node) => (this.printPart = node)}>
                <tbody>
                  <tr>
                    <td>ردیف</td>
                    <td>کد محصول</td>
                    <td>نام محصول</td>
                    <td>نام تامین کننده</td>
                    <td>تعداد</td>
                    <td>واحد شمارش</td>
                    <td className="priceCell">قیمت واحد</td>
                    <td className="priceCell">قیمت کل</td>
                    <td className="priceCell">تخفیف</td>
                    <td className="priceCell">قابل پرداخت</td>
                  </tr>
                  {this.state.printInfo.map((detail, index) => (
                    <tr key={'i' + index}>
                      <td>{(pageNumber - 1) * 10 + index + 1}</td>
                      <td>{detail.productCode}</td>
                      <td>{detail.productName}</td>
                      <td>{detail.providerName}</td>
                      <td>{detail.quantity}</td>
                      <td>{detail.productUnitTitle}</td>
                      <td className="priceCell">{accounting.formatMoney(detail.unitPrice, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(detail.totalAmount, '', ',')}</td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          Number(detail.discountAmount) + Number(detail.extraDiscountAmount),
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell">{accounting.formatMoney(detail.payableAmount, '', ',')}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>مجموع</td>
                    <td>{sumProduct + ''}</td>
                    <td colSpan={4} className="priceCell" />
                    <td colSpan={1} className="priceCell">
                      {accounting.formatMoney(sumPrice, '', ',') + ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>کد محصول</td>
                  <td>نام محصول</td>
                  <td>نام تامین کننده</td>
                  <td>تعداد</td>
                  <td>واحد شمارش</td>
                  <td className="priceCell">قیمت واحد</td>
                  <td className="priceCell">قیمت کل</td>
                  <td className="priceCell">تخفیف</td>
                  <td className="priceCell">قابل پرداخت</td>
                </tr>
                {this.state.subFactors.map((detail, index) => (
                  <React.Fragment>
                    <tr key={index}>
                      <td>{(pageNumber - 1) * 10 + index + 1}</td>
                      <td>{detail.productCode}</td>
                      <td>{detail.productName}</td>
                      <td>{detail.providerName}</td>
                      <td>{detail.quantity}</td>
                      <td>{detail.productUnitTitle}</td>
                      <td className="priceCell">{accounting.formatMoney(detail.unitPrice, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(detail.totalAmount, '', ',')}</td>
                      <td className="priceCell">
                        {accounting.formatMoney(
                          Number(detail.discountAmount) + Number(detail.extraDiscountAmount),
                          '',
                          ','
                        )}
                      </td>
                      <td className="priceCell">{accounting.formatMoney(detail.payableAmount, '', ',')}</td>
                    </tr>
                  </React.Fragment>
                ))}
                <tr>
                  <td colSpan={4}>مجموع</td>
                  <td>{sumProduct + ''}</td>
                  <td colSpan={4} className="priceCell" />
                  <td colSpan={1} className="priceCell">
                    {accounting.formatMoney(sumPrice, '', ',') + ''}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_DETAIL}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SubFactors
